import { render, staticRenderFns } from "./amostra.vue?vue&type=template&id=24972e7b"
import script from "./amostra.vue?vue&type=script&lang=js"
export * from "./amostra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports